import React, { FC } from 'react'

import { RewardsQuery } from '../../../../../../graphql/search'
import { useCustomerVipDiscount } from '../../../../../../lib/m2/hooks/useCustomerVipDiscount'
import { RewardsCardHeader, RewardsCardSubHeader } from '../../RewardsCard'
import { RewardsInformationTooltip } from '../../RewardsInformationTooltip'
import * as Styled from './styled'

export interface DfhRewardsCardProps {
  availableBalance: NonNullable<RewardsQuery['customer']>['availableBalance']
  previousSnapshot?: NonNullable<
    NonNullable<RewardsQuery['customer']>['rewardsSnapshots']
  >['nodes'][number]
}

export const DfhRewardsCard: FC<DfhRewardsCardProps> = ({ availableBalance, previousSnapshot }) => {
  const { isEligibleForVipDiscount } = useCustomerVipDiscount()

  return (
    <Styled.Card>
      <RewardsCardHeader>
        <RewardsCardSubHeader>
          <Styled.Heading2>DFH Rewards</Styled.Heading2>
          <RewardsInformationTooltip>
            Rewards earned through Commissions and Rebates and can be used online for greater value.
            Balance accumulates month over month.
          </RewardsInformationTooltip>
        </RewardsCardSubHeader>
      </RewardsCardHeader>
      <Styled.Container>
        {availableBalance && <Styled.YourRewardsCard availableBalance={availableBalance} />}
        {isEligibleForVipDiscount && (
          <>
            <Styled.VipDiscountCard previousSnapshot={previousSnapshot}>
              <Styled.Heading4>Current VIP Discount</Styled.Heading4>
            </Styled.VipDiscountCard>
          </>
        )}
      </Styled.Container>
    </Styled.Card>
  )
}
